export const getIsLoader = state => state.loader.isLoading;
